import { useCallback, useEffect } from 'react';

type IErrorDialog = {
  open: boolean;
  errorMessage: string;
  onClose: (open: boolean) => void;
};

const ErrorDialog = (props: IErrorDialog) => {
  const { open, errorMessage, onClose } = props;

  const handleClose = useCallback(() => {
    onClose(false);
  }, [onClose]);

  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handleClose();
      }
    };

    window.addEventListener('keydown', onKeyDown);

    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [open, handleClose]);

  if (!open) return null;

  return (
    <div className="dialog-overlay" role="presentation">
      <button className="dialog-backdrop-button" type="button" aria-label="閉じる" onClick={handleClose} />
      <div className="dialog-panel" role="dialog" aria-modal="true">
        <p className="dialog-message">{errorMessage}</p>
        <div className="dialog-actions">
          <button className="dialog-button" type="button" onClick={handleClose}>
            確認
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorDialog;
